app.service('mobilePhoneService', [
  '$http',
  function ($http) {
    this.verifyCode = function (params) {
      return $http({
        method: 'GET',
        url: '/api/mobile_phone_verifications/verify_code',
        params: {
          country_calling_code: params.countryCallingCode,
          mobile_phone: params.mobilePhone,
          code: params.code,
          is_forget_password: params.isForgetPassword,
        },
      });
    };

    this.sendCode = function (data) {
      return $http({
        method: 'POST',
        url: '/api/mobile_phone_verifications/send_code',
        data: {
          country_calling_code: data.countryCallingCode,
          mobile_phone: data.mobilePhone,
        },
      });
    };

    this.checkUserExistenceByPhone = function (params) {
      return $http({
        method: 'GET',
        url: '/api/users/exist',
        params: {
          country_calling_code: params.countryCallingCode,
          mobile_phone: params.mobilePhone,
        },
      });
    };
  },
]);
